(function () {
  'use strict';

  function controller() {
    return (input) => Math.floor(input);
  }

  app.filter('mathFloor', controller);
})();
